<div class="externalContainer">
    <div class="changeCard">
        <div class="logoContainer">
            <img class="logo" src="../../../../assets/bergara/logoBergara.png" />
        </div>

        <form [formGroup]="formEmail" class="loginForm" *ngIf="!emailSent">
            <div class="inputPassGroup">
                <mat-label class="labelPass">{{ 'recoverPassword.inputLabel' | transloco }}</mat-label>
                <input class="inputPass" matInput name="email" type="email" formControlName="email" maxlength="200" />
            </div>
        </form>

        <div style="display:flex; width: 100%; align-items: center; justify-content: center; margin-top: 12px;" *ngIf="!emailSent">
            <button class="buttonPass" (click)="enviarCorreoCambioContrasena()" [disabled]="!formEmail.valid">{{ 'recoverPassword.submit' | transloco }}</button>
        </div>

        <form [formGroup]="formCodigo" class="loginForm" style="margin-top: 24px;" *ngIf="emailSent && !codeVerified">
            <div class="inputPassGroup">
                <mat-label class="labelPass">{{ 'changePassword.codeTitle' | transloco }}</mat-label>
                <input class="inputPass" matInput name="codigo" type="text" formControlName="codigo" maxlength="10" />
            </div>
        </form>

        <div style="display:flex; width: 100%; align-items: center; justify-content: center; margin-top: 20px;" *ngIf="emailSent && !codeVerified">
            <button class="buttonPass" (click)="verificarCodigo()" [disabled]="!formCodigo.valid">{{ 'changePassword.verifyCode' | transloco }}</button>
        </div>

        <form [formGroup]="formCambiarContrasena" class="loginForm" style="margin-top: 40px;" *ngIf="codeVerified">
            <div class="inputPassGroup">
                <mat-label class="labelPass">{{ 'changePassword.title' | transloco }}</mat-label>
                <input class="inputPass" matInput name="password" type="password" formControlName="password" maxlength="200" />
            </div>

            <div class="inputPassGroup" style="margin-top: 54px;">
                <mat-label class="labelPass">{{ 'changePassword.confirmTitle' | transloco }}</mat-label>
                <input class="inputPass" matInput name="confirmPassword" type="password" formControlName="confirmpassword"
                    maxlength="200" />
            </div>
        </form>
        
        <div style="display:flex; width: 100%; align-items: center; justify-content: center;" *ngIf="codeVerified">
            <button class="buttonPass" (click)="cambiarPass()" [disabled]="!formCambiarContrasena.valid">{{ 'changePassword.button' | transloco }}</button>
        </div>
    </div>
</div>